export default "__VITE_ASSET__ff4bc68e__"